import { UserApiData } from '../../types/user';

export interface UserData {
	id: string;
	imageUrl: string;
	name: string;
	username: string;
}

export class User {
	id: string;
	imageUrl: string;
	name: string;
	username: string;

	constructor(data: UserData) {
		this.id = data.id;
		this.imageUrl = data.imageUrl;
		this.name = data.name;
		this.username = data.username;
	}

	public static fromApiData(data: UserApiData) {
		return new User({
			id: data.id,
			imageUrl: data.profile_pic_url,
			name: data.display_name,
			username: data.username,
		});
	}
}
